module.exports = __webpack_public_path__ + "assets/ic_photo.b2b03d31.svg";